import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const StyledHome = styled(motion.div)`
  height: 93vh;
  display: flex;
  position: relative;
  overflow: hidden;

  .infoleft {
    flex: 1;
    width: 50vw;
    background-color: #272c32;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    z-index: 10;
    @media (max-width: 700px) {
      width: 100vw !important;
      align-items: center;
    }
    h1 {
      box-sizing: border-box;
      color: white;
      font-family: "Roboto", sans-serif;
      font-weight: lighter;
      font-size: 8rem;
      line-height: 10rem;
      width: 50vw;
      padding: 0 10%;
      margin-bottom: 1.5rem;
      @media (max-width: 700px) {
        font-size: 6rem;
        padding: 0;
        span {
          text-align: center;
        }
        .third-line {
          display: inline;
        }
      }

      .accented {
        font-size: 8rem;
        display: inline-block;
        /* color: #EB212E; */
        color: #eb212e;
        font-weight: 500;

        @media (max-width: 700px) {
          font-size: 6rem;
        }
      }
    }
  }
  .inforight {
    z-index: 1;
    flex: 1;
    width: 50vw;
    background-color: #f7f7f7;
    position: relative;
    border-bottom: 1px solid #3f4652;
    @media (max-width: 700px) {
      width: 100vw !important;
    }
    h2 {
      transform: translateX(-0.2vw);
    }
    span {
      color: #eb212e;
    }
  }
`;

export const TransitionElem = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 5;
  background-color: #eb212e;
  width: 100vw;
`;
export const StyledSlideOne = styled(motion.div)`
  box-sizing: border-box;
  padding: 2rem;
  margin-bottom: 2 rem;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
  /* padding: 15rem 1vw; */
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 7rem;
    margin-bottom: 2.5rem;
  }
  h2,
  h3 {
    font-family: "DM Sans", sans-serif;
    color: #272c33;
  }

  .descbox {
    width: 90%;
    padding: 0 4rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    h3 {
      font-size: 2.5rem;
      text-transform: capitalize;
      letter-spacing: 0.1rem;
      margin-top: 0.5rem;
    }
  }

  .descriptor {
    text-align: left;
    width: 35%;
    padding: 3%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h3 {
      font-size: 3.5rem;
      margin-right: 0;
    }

    img {
      /* filter: grayscale(100%) sepia(35%) brightness(80%) saturate(503%) contrast(150%) invert(10%); */
      filter: grayscale(0.3);
      width: 10rem !important;
      height: 10rem !important;
    }
  }
  .maintain {
    border-right: 2px solid #272c32;
    border-bottom: 2px solid #272c32;
  }
  .optimized {
    border-left: 2px solid #272c32;
    border-bottom: 2px solid #272c32;
  }
  .scalable {
    border-right: 2px solid #272c32;
    border-top: 2px solid #272c32;
  }
  .clean {
    border-left: 2px solid #272c32;
    border-top: 2px solid #272c32;
  }

  .desc__bot {
    display: flex;

    .scalable {
      padding: 2rem 2.5rem;
      border-right: 2px solid #9ab4c2;
    }
    .maintainable {
      padding: 2rem 2.5rem;
    }
  }
`;
export const StyledSlideTwo = styled(motion.div)`
  display: flex;
  align-items: center;
  height: 100%;
  color: #272c33;
  h2 {
    color: #272c33;
  }
  p {
    text-align: center;
    color: #272c33;
    font-weight: 550;
    padding: 10%;
    font-size: 4rem;
    line-height: 5.5rem;
    font-family: "DM Sans", sans-serif;
    span {
      font-weight: 550;
      color: #eb212e;
    }
  }

  button {
    all: unset;
    border: 1px solid transparent;
    padding: 1rem 5.5rem;
    border-radius: 100px;
    font-family: inherit;
    outline: none;
    background-color: #272c33;
    color: rgb(255, 255, 255);
    text-transform: capitalize;
    font-size: 2.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    transition:
      color 0.3s ease 0s,
      border-color 0.3s ease 0s;
    text-transform: capitalize;
    font-size: 2.5rem;
    text-align: center;
    cursor: pointer;
    align-items: center;
    margin: 4rem auto;
    transition:
      color 0.3s,
      border-color 0.3s;
    &:hover {
      color: #eb212e;
      border-color: #eb212e;
    }
  }
`;
export const StyledSlideThree = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: center;
  font-family: "DM Sans", sans-serif;
  color: #272c33;
  h2 {
    color: #272c33;
    font-size: 5rem;
  }
  p {
    color: #272c33;
    margin-top: -0.5rem;
    padding: 1.5rem 10rem;
    font-size: 3rem;
    font-weight: 550;
    line-height: 5rem;
  }
  a:link,
  a:active,
  a:visited {
    padding: 0 0.5rem;
    display: inline-block;
    text-decoration: none;
    color: #db4d4e;
  }

  button {
    all: unset;
    border: 1px solid transparent;
    padding: 2rem 5.5rem;
    border-radius: 100px;
    font-family: inherit;
    outline: none;
    background-color: #272c33;
    color: rgb(255, 255, 255);
    text-transform: capitalize;
    font-size: 2.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    transition:
      color 0.3s ease 0s,
      border-color 0.3s ease 0s;
    text-transform: capitalize;
    font-size: 2.5rem;
    text-align: center;
    cursor: pointer;
    align-items: center;
    margin: 1.5rem auto;
    transition:
      color 0.3s,
      border-color 0.3s;
    &:hover {
      color: #eb212e;
      border-color: #eb212e;
    }
  }
`;
export const StyledLink = styled(Link)`
  z-index: 50;
  text-decoration: none;
  font-size: 3.5rem;
  svg {
    width: 4rem;
  }
  display: inline-block;
  padding-top: 2rem;
  color: white;
`;
export const StyledNav = styled(motion.nav)`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  height: 6vh;
  display: flex;
  padding: 1rem 10vw;
  justify-content: space-between;
  align-items: center;
  font-size: 2rem;
  background-color: #0a0a0a;

  & > * {
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }
  .logobox {
    border: 2px solid green;
  }

  .navimage {
    a {
      display: inline-block;
      width: 100%;

      img {
        width: 30px;
        height: 30px;
        display: block;
      }
    }
  }
`;

export const Styledul = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  font-family: "Lato", sans-serif;
  li {
    position: relative;
    margin-left: 3.5rem;
    padding-bottom: 0.5rem;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 0%;
      width: 0;
      visibility: hidden;
      background-color: #9ab4c2;
      padding: 0.1rem;
      transition: width 500ms cubic-bezier(0.535, -0.355, 0.43, 1.47);
    }
    &:hover::after {
      width: 90%;
      visibility: visible;
    }
    &:last-child::after {
      content: "";
      padding: 0;
    }
    a,
    button {
      background-color: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      text-decoration: none;
      color: white;
      text-transform: uppercase;
      font-size: 1.7rem;
      letter-spacing: 2px;
      transition: all 0.3s ease;
      position: relative;
      img {
        padding-top: 0.1rem;
        height: 3.5rem;
      }
    }
  }
`;
//reusable line for skills section
export const Line = styled.div`
  width: 70%;
  height: 0.3rem;
  margin: 2rem auto;
  border-radius: 2rem;
  background-color: ${(props) => {
    return props.color;
  }};
`;
//skills section styling
export const StyledSkills = styled(motion.div)`
  padding: 10rem;
  background-color: #253244;
  font-family: "Roboto", sans-serif;
  h2 {
    font-size: 5rem !important;
  }
  .aboutme {
    font-size: clamp(1.5rem, 3.5rem, 1.5vw) !important;
    line-height: clamp(2.5rem, 5.5rem, 3vw);
    text-transform: none;
    font-family: "Roboto", sans-serif;
    margin-top: 5rem;
    font-weight: 400;
    color: #e9eff2;
    span {
      color: #eb212e;
    }
    span a:link,
    a:hover,
    a:visited {
      color: #eb212e;
      text-decoration: underline;
      display: inline-block;
      margin-left: 0.5rem;
      transition: all 0.3s ease;
      &:hover {
        color: #d0121f;
      }
    }
  }
  .skillset {
    display: flex;
    margin-top: 5rem;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    .desc {
      margin-bottom: 5rem;
      font-family: "Roboto", sans-serif;
      letter-spacing: 0.5rem;
      word-spacing: -0.2rem;
      color: white;
      font-size: 4rem;
      /* side by side design */
      /* flex-basis: 45%; */
      /* padding-left: 5rem; */
      /* display: flex; */
      /* align-items: center;
    justify-content: space-evenly; */

      span {
        /* display: inline-block; */
        display: block;
        margin-top: 1.5rem;
        width: 120%;
        transform: translateX(-10%);
        height: 0.4rem;
        border-radius: 2rem;
        background-color: #eb212e;
      }
    }
  }
  .skillsetIcons {
    width: 90%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    & > * {
      filter: contrast(100%);
      transition: filter 0.2s ease;
      cursor: pointer;
    }
    & > *:hover {
      filter: contrast(120%);
    }
    & > div > svg {
      width: 16rem;
      height: 16rem;
    }
    .logobox {
      text-align: center;
      width: 17%;

      p {
        color: #eaeaea;
        font-size: 2rem;
        line-height: 3.5rem;
        max-width: max-content;
        font-family: "Roboto", sans-serif;
      }

      &:last-of-type svg {
        transform: translateX(2.5rem);
      }
    }
  }
  h2 {
    font-family: "Roboto", sans-serif;
    color: #f7f7f7;
    letter-spacing: 2.5px;
    text-align: center;
    font-size: 4rem;
  }
  .otherskills {
    margin-top: 5rem;
    padding: 5rem 20rem;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    .flexgroup {
      flex-basis: 35%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      h4 {
        flex-basis: 35%;
        font-size: 2rem;
        letter-spacing: 0.1rem;
        color: #eaeaea;
      }
      span {
        display: block;
        width: 30%;
        height: 0.4rem;
        border-radius: 2rem;
        background-color: #eb212e;
      }
    }

    .skilllist {
      flex-basis: 65%;
      font-size: 2rem;
      display: flex;
      justify-content: space-evenly;
    }
    .skillitem {
      width: 10%;
      height: 12rem;
      display: flex;
      color: #c4c4c4;
      flex-direction: column;
      justify-content: space-evenly;
      .css svg {
        transform: translateX(-10%);
      }

      .skillicon {
        display: block;
        margin: 0 auto;
        width: 90%;

        & > * {
          display: block;
          width: 80%;
          margin: 0 auto;
          height: 50px;
        }
      }
      .skillname {
        text-align: center;
        font-weight: 500;
        color: #eaeaea;
        font-size: 1.8rem;
      }

      &.styled .skillname {
        font-size: 1.5rem;
      }
      &.styled .skillicon {
        margin: 2rem auto 1rem;
        width: 30%;
      }
      .framer {
        font-size: 1.5rem;
      }
    }
  }

  .languages,
  .futuregoals {
    padding: 5rem 20rem;
    color: #eaeaea;
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
    .flexgroup {
      display: flex;
      flex-basis: 35%;
      align-items: center;
      justify-content: space-evenly;

      h4 {
        flex-basis: 35%;
        font-size: 2rem;
        letter-spacing: 0.1rem;
        color: #eaeaea;
      }

      span {
        display: block;
        width: 30%;
        height: 0.4rem;
        border-radius: 2rem;
        background-color: #eb212e;
      }
    }
    div {
      flex-basis: 65%;
      font-size: 2rem;
      p {
        padding-left: 5%;
      }
    }
  }
`;

export const StyledFooter = styled(motion.div)`
  padding: 5rem 15rem;
  background-color: #0a0a0a;
  font-size: 3rem;
  font-family: "Roboto", sans-serif;
  h2 {
    /* color:#EB212E */
    color: #fff;
    display: block;
    text-align: center;
    position: relative;
    padding: 0;
    margin: 0 auto;
    font-size: 5rem;
    margin-bottom: 5rem;
    ::after {
      content: "";
      display: block;
      position: absolute;
      top: 120%;
      left: 50%;
      background-color: #eb212e;
      width: 20%;
      height: 0.4rem;
      transform: translateX(-50%);
    }
  }

  h3 {
    margin-top: 2rem;
    color: green;
    text-align: center;
  }
  h3 {
    color: #f7f7f7;
    font-size: 2rem;
    text-align: center;
    letter-spacing: 0.18rem;
  }
  label {
    color: #e9eff2;
    font-size: 1.9rem;
    letter-spacing: 0.2rem;
    margin-right: 2rem;
    font-weight: 500;
    width: 6.5rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
    display: block;
  }
  input[type="text"],
  textarea {
    background-color: #566271;
    color: #fff;
    font-size: 2rem;
    font-family: "Roboto", sans-serif;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 1.5rem 1rem;
    width: 15rem;
    resize: none;
    border-radius: 0.3rem;
    border: 3px solid transparent;
    transition: all 0.3s ease-in-out;
    width: 100%;
    &:focus {
      border-color: #9ab4c2;
    }
  }
  textarea {
    width: 100%;
    height: 20rem;
  }
  form {
    width: 120%;
    padding-top: 1%;
    margin: 5rem auto;
    display: flex;
    flex-direction: column;
    transform: scale(1.1);
    @media (max-width: 800px) {
      width: 100%;
    }
  }
  .flexmid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between !important;

    @media (max-width: 800px) {
      flex-direction: column;
      overflow: hidden;
    }
    .email {
      color: #fff;
      margin-top: 12rem;
      transform: translateX(-20%);
      width: 50%;
      @media (max-width: 800px) {
        transform: translateX(0);
        margin: 0 auto;
        margin-bottom: 10rem;
      }

      p {
        font-size: 2.5rem;
        text-decoration: underline;
      }
    }
  }
  .formwrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-self: center;
    justify-self: center;
    justify-content: center;
    width: 60%;
  }
  .inputwrap {
    flex-basis: 100%;
  }
  .messagewrap {
    height: 100%;
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    label {
      width: 8rem;
      display: block;
      margin-bottom: 2rem;
    }
  }
  button {
    flex-basis: 30%;
    align-self: flex-start !important;
    justify-self: flex-start !important;
    margin: 5rem 0 !important;
    display: inline-block;
    font-size: 2rem;
    font-weight: 700;
    color: #e9eff2;
    background-color: transparent;
    border: none;
    outline: none;
    border: 1px solid #9ab4c2;
    padding: 1.5rem 2.5rem;
    cursor: pointer;
    box-shadow: 0.1px 0.1px 2px #000;
    transition: all 0.3s ease;
    overflow: hidden;
    font-smooth: antialiased;
    backface-visibility: hidden;
    transform: translateX(-115%);
    @media (max-width: 800px) {
      transform: translateX(0);
      flex-basis: 50%;
    }
    &:hover {
      color: #eb212e;
      border-color: #eb212e;
      box-shadow: 0.1px 0.1px 4px #000;
    }
    &:active {
      box-shadow: 0.1px 0.1px 1px #000;
      transform: translateY(0.2rem);
    }
  }
  .scrollTop {
    font-size: 5rem;
    width: 20%;
    margin: auto;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    padding: 0;
    transform: translateY(-5rem) scale(1.2);
    color: #eb212e;
  }
  p {
    text-align: center;
    margin-top: -3rem;
    font-size: 1.8rem;
    color: #eaeaea;
    span {
      color: #eb212e;
      font-weight: 700;
    }
  }
`;
